import React from "react";
import { ButtonProps } from "@mui/material/Button/Button";
import { Button } from "./Button";

export const CreateButton = (props: ButtonProps) => {
  return <Button {...props}>{props.children}</Button>;
};
